import React from 'react';
import styles from 'app/home/hierarchy/HierarchyPanel.styles';
import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';

interface HierarchyCommonItemProps {
    label: string;
    onClick: () => void;
    isActive: boolean;
    icon: string;
    dataTest?: string;
}
export default function HierarchyCommonItem(props: HierarchyCommonItemProps) {
    const { label, onClick = () => {}, isActive, icon, dataTest } = props;
    return (
        <Box
            sx={styles.commonItemLink}
            onClick={onClick}
            className={`common-item ${isActive ? 'active' : ''}`}
            data-test={dataTest}
        >
            <Box sx={styles.commonItemLinkIcon} className={'common-item__icon'}>
                <IconMi icon={icon} fontSize={'16'} />
            </Box>
            <Box sx={styles.commonItemLinkLabel} className={'common-item__label'}>
                <Box sx={styles.commonItemLinkLabelAlign}>{label}</Box>
            </Box>
        </Box>
    );
}
